import { Directive, Input, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { CurrentUserService } from '../../security/services/CurrentUserService';

@Directive({
  selector: '[brdAccessPermission]'
})
export class AccessPermissionDirective {
  private hasView: boolean;

  @Input('brdAccessPermission')
  set permission(permissions: string | string[]) {
    var condition = this.currentUserService.hasPermission(permissions);
    if (condition && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!condition && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  } 

  constructor(private currentUserService: CurrentUserService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef) {
  }
  
}



// WEBPACK FOOTER //
// ./src/app/core/directives/access-permission.directive.ts